import React, { type PropsWithChildren } from 'react'
import {
  Image, ImageProps,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  type ModalProps,
  type StackProps
} from '@chakra-ui/react'

import { ErrorContent, type ErrorContentProps } from '../content'
import useMediaQuery from '../../__utils__/useMediaQuery'
import { breakpoints } from '../../theme/foundations/breakpoints'

export type ErrorModalProps = PropsWithChildren<
  & Omit<ModalProps, 'children' | 'onClose'>
  & ErrorContentProps
  & {
  // Won't show on smaller screen sizes
  imageBottomRightSrc?: string | null
  onClose?: () => any
  contentStyles?: StackProps
  modalBodyStyles?: StackProps
  modalContentStyles?: StackProps
}>

export const noop = () => {
  // intentional no-op
}

/**
 * WIP design from Andrew Hayley here
 * https://www.figma.com/file/Owz4xFAnzWeofkYhWMBV7D/Avatar-System?node-id=4002%3A85837&t=mHuhg5W3JbUuuDWd-1
 */
export function ErrorModal({
  headingText,
  messageText,
  imageSrc,
  imageBottomRightSrc = null,
  buttons = null,
  children,
  onClose = noop,
  layout,
  contentStyles,
  modalBodyStyles,
  modalContentStyles,
  ...restProps
}: ErrorModalProps) {
  const modalProps = layout ==='vertical' ? { maxW: '640px' } : {}
  const modalBodyProps = layout ==='vertical' ? { py: '46px' } : {}

  return (
    <Modal
      size={'base'}
      onClose={onClose}
      {...restProps}
    >
      <ModalOverlay />

      <ModalContent {...modalProps} {...modalContentStyles}>
        <ModalBody {...modalBodyProps} {...modalBodyStyles}>
          <ErrorContent
            position={'relative'}
            zIndex={1}
            messageText={messageText}
            headingText={headingText}
            buttons={buttons}
            imageSrc={imageSrc}
            children={children}
            layout={layout}
            {...contentStyles}
          />

          {imageBottomRightSrc && <BottomRightImage src={imageBottomRightSrc} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

function BottomRightImage(props: ImageProps) {
  const isLargeEnough = useMediaQuery(
    `(min-width: ${breakpoints.modalContentMedium})`,
  )

  if (!isLargeEnough) {
    return null
  }

  return (
    <Image
      zIndex={0}
      position={'absolute'}
      bottom={0}
      right={0}
      alt={'Error'}
      maxW={'500px'}
      {...props}
    />
  )
}

